<template>
	<a class="clrbtn btn-tskr btn-success" @click.prevent="accept" href="#"
		>Accept this offer</a
	>
</template>

<script>
import Swal from "sweetalert2";
export default {
	name: "accept-offer",
	props: {
		offer_id: {
			type: [String, Number],
			required: true
		}
	},

	data() {
		return {};
	},
	created() {},
	methods: {
		accept: function() {
			let self = this;
			Swal.fire({
				type: "question",
				text: `Do you really want to accept this offer and select this trader?`,
				confirmButtonText: "YES",
				cancelButtonText: "NO",
				showCancelButton: true,
				showCloseButton: true
			}).then(result => {
				if (result.value) {
					self.$Progress.start();
					axios({
						method: "post",
						url: "/dashboard/offer/" + self.offer_id + "/accept"
					})
						.then(function(res) {
							self.$Progress.finish();
							self.$toast.success(res.data.msg);

							location.reload();
						})
						.catch(function(err) {
							self.$Progress.fail();
							if (err.response.status == 422) {
								self.errors = err.response.data.errors;
								for (let error in self.errors) {
									self.$toast.error(self.errors[error][0]);
								}
							} else if (err.response.status == 403) {
								self.$toast.error(err.response.data.message);
							} else {
								console.log(err.response.data.message);
							}
						});
				}
			});
		}
	}
};
</script>
